define('products',['jquery', 'core', 'site'], function ($, core, site) {
    var module = {};
    var browserSupportsHistoryStateFunctions = !!(window.history && window.history.replaceState);
    var filteredOnMobileFilter = false; //Should mobile filter be synced after filter closed with Cancel button or desktop synced after filter applied with Apply button

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    function closeMobileFilter() {
        $('html').removeClass('modal-on filter-open');
        $('.js-show-mobile-filter').removeClass('active-filter');
        $('.js-tab-toggle[data-tab-index="categories"]').click(); //Activate first tab
    }

    function submitGallery(options) {
        var showClearAll = false;
        var isMobileFilter = !!options.IsMobileFilter;
        var noScrollAnimation = !!options.NoScrollAnimation;
        var resetPageNumber = !!options.ResetPageNumber;
        var resetAll = !!options.ResetAll;
        var syncMobileFilter = !!options.SyncMobileFilter;
        var applyMobileFilter = !!options.ApplyMobileFilter;

        filteredOnMobileFilter = isMobileFilter;

        var loadFromMobileFilters = isMobileFilter && !resetAll || applyMobileFilter;
        var lockMobileFilters = isMobileFilter && !resetAll || syncMobileFilter;

        var lockSelector = lockMobileFilters ? '.js-products-mobile-filter-navigation' : '.js-product-gallery-content';
        if (applyMobileFilter || isMobileFilter && resetAll) {
            lockSelector = "screen";
        }

        //Featured looks should be collapsed after a user applies a filter
        var collapseFeaturedLooks = function () {
            if (!isMobileFilter && !syncMobileFilter || resetAll || applyMobileFilter) {
                $('.js-toggle-top-section:not(.active-item)').click();
            }
        }

        collapseFeaturedLooks();

        var filtersContainer = $(loadFromMobileFilters ? '.js-products-mobile-filter-navigation' : '.js-products-filter-navigation');
        var originalForm = $('.js-product-gallery-form');
        var form = originalForm;

        if (form.length) {
            var doAjaxRequest = browserSupportsHistoryStateFunctions || isMobileFilter || syncMobileFilter;
            if (doAjaxRequest) {
                form = form.clone();
            }

            //Do update mobile filters
            var formIsMobileFilter = form.find('.js-product-gallery-is-mobile-filter');
            if (!isMobileFilter) {
                formIsMobileFilter.remove();
            } else {
                formIsMobileFilter.val(isMobileFilter);
            }

            //Sync mobile filter
            var formSyncMobileFilter = form.find('.js-product-gallery-sync-mobile-filter');
            if (!syncMobileFilter) {
                formSyncMobileFilter.remove();
            } else {
                formSyncMobileFilter.val(syncMobileFilter);
            }

            //Apply mobile filter
            var formApplyMobileFilter = form.find('.js-product-gallery-apply-mobile-filter');
            if (!formApplyMobileFilter) {
                formApplyMobileFilter.remove();
            } else {
                formApplyMobileFilter.val(applyMobileFilter);
            }

            //Last filter type
            var formLastFilter = form.find('.js-product-gallery-last-filter');
            if (formLastFilter.val() == formLastFilter.data('default-value')) {
                formLastFilter.remove();
            }

            //Page number
            var formPageNumber = form.find('.js-product-gallery-page-number');
            if (formPageNumber.val() == formPageNumber.data('default-value') || resetPageNumber) {
                formPageNumber.remove();
            }

            //Page size
            var formPageSize = form.find('.js-product-gallery-page-size');
            if (formPageSize.val() == formPageSize.data('default-value')) {
                formPageSize.remove();
            }

            //Sort by
            var formSortBy = form.find('.js-product-gallery-sort-by');
            if (formSortBy.val() == formSortBy.data('default-value')) {
                formSortBy.remove();
            }

            //In stock
            var inStockCheckbox = filtersContainer.find('.js-product-gallery-select-in-stock');
            var inStockValue = inStockCheckbox.prop('checked') ? inStockCheckbox.data('checked-value') : inStockCheckbox.data('unchecked-value');
            var formInStock = form.find('.js-product-gallery-in-stock');
            formInStock.val(inStockValue);
            if (formInStock.val() == formInStock.data('default-value')) {
                formInStock.remove();
            }

            var categoryIdTemplate = form.find('.js-product-gallery-category-id-template');
            var filterCategoryId = filtersContainer.find('.js-trigger-category.active').data('category-id');
            if (filterCategoryId) {
                var filterCategoryInput = categoryIdTemplate.clone();
                filterCategoryInput.val(filterCategoryId);
                categoryIdTemplate.before(filterCategoryInput);
            }
            categoryIdTemplate.remove();

            //Sizes
            var sizeTemplate = form.find('.js-product-gallery-size-template');
            filtersContainer.find('.js-refinement-size.size-box-active').each(function (index, value) {
                showClearAll = true;

                var refindmentSize = $(value).val();
                var refinementSizeInput = sizeTemplate.clone();
                refinementSizeInput.val(refindmentSize);
                sizeTemplate.before(refinementSizeInput);
            });
            sizeTemplate.remove();

            //Colors
            var colorTemplate = form.find('.js-product-gallery-color-template');
            filtersContainer.find('.js-refinement-color.rb-color-active').each(function (index, value) {
                showClearAll = true;

                var refindmentColor = $(value).data("color-name");
                var refinementColorInput = colorTemplate.clone();
                refinementColorInput.val(refindmentColor);
                colorTemplate.before(refinementColorInput);
            });
            colorTemplate.remove();

            //Designers
            var designerIdTemplate = form.find('.js-product-gallery-designer-id-template');
            filtersContainer.find('.js-refinement-designer:checked').each(function (index, value) {
                showClearAll = true;

                var refindmentDesignerId = $(value).val();
                var refinementDesignerInput = designerIdTemplate.clone();
                refinementDesignerInput.val(refindmentDesignerId);
                designerIdTemplate.before(refinementDesignerInput);
            });
            designerIdTemplate.remove();

            if (resetAll) {
                if (browserSupportsHistoryStateFunctions) {
                    var originalFormLastFilterInput = originalForm.find('.js-product-gallery-last-filter');
                    var originalFormPageNumberInput = originalForm.find('.js-product-gallery-page-number');
                    var originalFormPageSizeInput = originalForm.find('.js-product-gallery-page-size');
                    var originalFormSortByInput = originalForm.find('.js-product-gallery-sort-by');
                    var originalFormInStockInput = originalForm.find('.js-product-gallery-in-stock');

                    originalFormLastFilterInput.val(originalFormLastFilterInput.data('default-value'));
                    originalFormPageNumberInput.val(originalFormPageNumberInput.data('default-value'));
                    originalFormPageSizeInput.val(originalFormPageSizeInput.data('default-value'));
                    originalFormSortByInput.val(originalFormSortByInput.data('default-value'));
                    originalFormInStockInput.val(originalFormInStockInput.data('default-value'));

                    originalForm.find('.js-product-gallery-other-keywords').remove();
                }

                showClearAll = false;
                form.find('input').remove();
            }

            if (doAjaxRequest) {
                form.data('lock', lockSelector);
                core.dom.doAction(form, function () {
                    if (!isMobileFilter && !syncMobileFilter || resetAll) {
                        form.find('.js-product-gallery-last-filter, .js-product-gallery-apply-mobile-filter, .js-product-gallery-is-mobile-filter').remove(); //Do not show in URL
                        var query = form.serialize();
                        var url = form.attr('action') + (query.length ? '?' + query : '');
                        window.history.replaceState(undefined, '', url);
                    }

                    if (showClearAll) {
                        $('.js-product-gallery-clear-all').removeClass('hide-container');
                    } else {
                        $('.js-product-gallery-clear-all').addClass('hide-container');
                    }

                    if (!isMobileFilter && !syncMobileFilter && !applyMobileFilter && !core.ui.isElementInViewport($('.js-product-gallery-scroll-to'))) {
                        var $scrollToElement = $('.js-product-gallery-scroll-to');
                        if (noScrollAnimation) {
                            $('html, body').scrollTop($scrollToElement.offset().top);
                        } else {
                            core.ui.scrollTo($scrollToElement);
                        }
                    }
                });
            } else {
                core.ui.lock('screen', undefined, true);
                form.submit();
            }
        }
    }

    module.slideTopContent = function (context) {
        var slidingBlock = $('.sliding-block');
        context.andFind('.js-toggle-top-section').on('click', function (e) {
            e.preventDefault();
            var self = $(this);
            if (self.hasClass('active-item')) {
                slidingBlock.removeClass('section-toggled');
                self.removeClass('active-item').text('Collapse Looks');
            } else {
                slidingBlock.addClass('section-toggled');
                self.addClass('active-item').text('View Looks');
            }
        });
    };

    module.triggerFilteredDesigners = function (context) {
        var triggerDesigners = context.andFind('.js-toggle-designers-lists');
        var mainWrapper = context.andFind('.filtered-designers');
        var self;
        triggerDesigners.on('click', function () {
            self = $(this);
            if (mainWrapper.hasClass('active')) {
                mainWrapper.removeClass('active');
            } else {
                mainWrapper.addClass('active');
            }
        });
    };

    module.onProductGalleryAction = function (context) {
        function isMobileFilterByContext(filterContext) {
            return $(filterContext).closest('.js-products-mobile-filter-navigation').length > 0;
        }

        function clearSizeSelections() {
            $('.js-refinement-size.size-box-active').removeClass('size-box-active');
        }

        function collapseCategories() {
            $('.js-parent-category-li.category-expanded').removeClass('category-expanded').find("> ul").slideUp();
        }

        function expandCategory($parentLi) {
            if (!$parentLi.hasClass('category-expanded')) {
                var $ul = $parentLi.find("> ul");
                if ($ul.length) { //Has children
                    $ul.slideDown(function () {
                        $parentLi.addClass('category-expanded');
                    });
                } else {
                    $parentLi.addClass('category-expanded');
                }
            }
        }

        function deactivateCategories() {
            $('.js-all-categories-li.category-expanded').removeClass('category-expanded'); //Collapse "All Categories" (the same as normal category deactivation)
            $('.js-trigger-category.active').removeClass('active');
        }

        //All categories click
        context.andFind('.js-trigger-all-categories').click(function (e) {
            e.preventDefault();
            var $this = $(this);

            var $li = $this.parents('.js-all-categories-li');
            if (!$li.hasClass('category-expanded')) {
                

                deactivateCategories();
                collapseCategories();
                clearSizeSelections();

                expandCategory($li);

                var formLastFilter = $('.js-product-gallery-last-filter');
                formLastFilter.val(formLastFilter.data('type-category'));

                submitGallery({
                    IsMobileFilter: isMobileFilterByContext(this),
                    ResetPageNumber: true
                });
            }
        });

        //Parent category click
        context.andFind('.js-trigger-parent-category').click(function (e) {
            e.preventDefault();
            var $this = $(this);

            var $parentLi = $this.parents('.js-parent-category-li');
            var isParentExpanded = $parentLi.hasClass('category-expanded');

            if (isParentExpanded) {
                if (isMobileFilterByContext(this)) {
                    collapseCategories();
                }
                return;
            } else {
                if ($this.hasClass('disabled')) {
                    return;
                }

                collapseCategories();
                expandCategory($parentLi);

                clearSizeSelections();

                //Click child "All" item
                if ($parentLi.find('.js-trigger-category.active').length == 0) {
                    var categoryId = $this.data('category-id');
                    $parentLi.find('.js-trigger-category[data-category-id="' + categoryId + '"]').click();
                }
            }
        });

        //Category click
        context.andFind('.js-trigger-category').click(function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.hasClass('disabled')) {
                return;
            }

            //If category is not active then load category items
            if (!$this.hasClass('active')) {
                deactivateCategories();

                var categoryId = $this.data('category-id');
                var $parentLi = $this.closest('.js-parent-category-li');
                var parentCaregoryId = $parentLi.find('.js-trigger-parent-category').data('category-id');
                if (parentCaregoryId && parentCaregoryId == categoryId) { //If selected "All" then size can't be selected
                    clearSizeSelections();
                }

                if (!parentCaregoryId) { //It is parent category (doesn't have parent)
                    collapseCategories();
                    expandCategory($parentLi);
                }

                $this.addClass('active');

                var formLastFilter = $('.js-product-gallery-last-filter');
                formLastFilter.val(formLastFilter.data('type-category'));

                submitGallery({
                    IsMobileFilter: isMobileFilterByContext(this),
                    ResetPageNumber: true
                });
            }
        });

        //Refinement triggers
        context.andFind('.js-refinement-designer').click(function (e) {
            var $this = $(this);

            if ($this.hasClass('disabled')) {
                e.preventDefault();
                return;
            }

            var isMobileFilter = isMobileFilterByContext(this);

            if (isMobileFilter) {
                if ($this.prop('checked')) { //Copy to selected list
                    var $designerLiClone = $this.closest('.js-refinement-designer-li').clone();
                    var $designerCheckboxClone = $designerLiClone.find('.js-refinement-designer');
                    $designerCheckboxClone.off('click');
                    $designerCheckboxClone.removeClass('js-refinement-designer').addClass('js-refinement-designer-mobile-selected');
                    $('.js-mobile-selected-designers-container ul').append($designerLiClone);
                    core.scopes.update($designerLiClone);

                    //Sort selected designers
                    $('.js-refinement-designer-mobile-selected')
                        .closest('.js-refinement-designer-li')
                        .sort(function (a, b) { return $(a).data('designer-name').toLowerCase() > $(b).data('designer-name').toLowerCase() ? 1 : -1; })
                        .appendTo('.js-mobile-selected-designers-container ul');

                } else { //Remove from selected list
                    var designerId = $this.val();
                    $('.js-refinement-designer-mobile-selected[value="' + designerId + '"]').closest('.js-refinement-designer-li').remove();
                }

                var selectedDesignersCount = $('.js-refinement-designer-mobile-selected').length;
                if (selectedDesignersCount == 0) {
                    $('.js-mobile-designers-tab').addClass('hide-selected-designers');
                    $('.js-mobile-selected-designers-container').removeClass('active');
                } else {
                    $('.js-mobile-designers-tab').removeClass('hide-selected-designers');
                }
                $('.js-mobile-selected-designers-count').html(selectedDesignersCount);
            }

            var formLastFilter = $('.js-product-gallery-last-filter');
            formLastFilter.val(formLastFilter.data('type-designer'));

            submitGallery({
                IsMobileFilter: isMobileFilter,
                ResetPageNumber: true
            });
        });

        //Remove item  from selected list and click on designer in list
        context.andFind('.js-refinement-designer-mobile-selected').click(function () {
            var $this = $(this);
            var designerId = $this.val();
            $('.js-products-mobile-filter-navigation .js-refinement-designer[value="' + designerId + '"]').click();
            $this.closest('.js-refinement-designer-li').remove();
        });

        context.andFind('.js-refinement-color').click(function (e) {
            e.preventDefault();

            if ($(this).hasClass("rb-color-active")) {
                $(this).removeClass("rb-color-active");
            } else {
                $(this).addClass("rb-color-active");
            }

            var formLastFilter = $('.js-product-gallery-last-filter');
            formLastFilter.val(formLastFilter.data('type-color'));

            submitGallery({
                IsMobileFilter: isMobileFilterByContext(this),
                ResetPageNumber: true
            });
        });

        context.andFind('.js-refinement-size').click(function (e) {
            e.preventDefault();

            if ($(this).hasClass("size-box-active")) {
                $(this).removeClass("size-box-active");
            } else {
                $(this).addClass("size-box-active");
            }

            var formLastFilter = $('.js-product-gallery-last-filter');
            formLastFilter.val(formLastFilter.data('type-size'));

            submitGallery({
                IsMobileFilter: isMobileFilterByContext(this),
                ResetPageNumber: true
            });
        });

        context.andFind('.js-product-gallery-select-in-stock').click(function () {
            submitGallery({
                IsMobileFilter: isMobileFilterByContext(this),
                ResetPageNumber: true
            });
        });

        context.andFind('.js-product-gallery-remove-other-keyword').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            var keyword = $this.data('value');

            $('.js-product-gallery-other-keywords[value="' + keyword + '"]').remove();  //Form field
            $('.js-product-gallery-remove-other-keyword[data-value="' + keyword + '"]') //Desktop and mobile controls
                .closest('.js-bubble-wrapper')
                .remove();   

            submitGallery({
                IsMobileFilter: isMobileFilterByContext(this),
                ResetPageNumber: true
            });
        });

        context.andFind('.js-product-gallery-clear-all').click(function (e) {
            e.preventDefault();

            $('.js-designer-filter').val('');
            $('.js-designer-filter').trigger('input');
            $('.js-refinement-designer').prop('checked', false);

            $('.js-parent-category-li.category-expanded').removeClass('category-expanded');
            $('.js-trigger-category.active').removeClass('active');
            $('.js-all-categories-li').addClass('category-expanded');

            var inStockCheckbox = $('.js-product-gallery-select-in-stock');
            inStockCheckbox.prop('checked', inStockCheckbox.data('is-checked-by-default'));

            $('.js-product-gallery-remove-other-keyword').closest('.js-bubble-wrapper').remove();

            var isMobileFilter = isMobileFilterByContext(this);
            if (isMobileFilter) {
                closeMobileFilter(); 
            }

            submitGallery({
                IsMobileFilter: isMobileFilter,
                ResetAll: true
            });
        });

        context.andFind('.js-product-gallery-mobile-sort-by-action').change(function () {
            var currentSortByVal = $(this).val();
            var formSortBy = $('.js-product-gallery-sort-by');
            formSortBy.val(currentSortByVal);

            submitGallery({ IsMobileFilter: false, ResetPageNumber: true });
        });

        context.andFind('.js-product-gallery-sort-by-action').change(function () {
            var currentSortByVal = $(this).val();
            var formSortBy = $('.js-product-gallery-sort-by');
            formSortBy.val(currentSortByVal);

            submitGallery({ IsMobileFilter: false, ResetPageNumber: true });
        });

        context.andFind('.js-product-gallery-page-size-action').change(function () {
            var selectedPageSize = $(this).val();
            var formPageSize = $('.js-product-gallery-page-size');
            formPageSize.val(selectedPageSize);

            submitGallery({
                IsMobileFilter: isMobileFilterByContext(this),
                ResetPageNumber: true,
                NoScrollAnimation: true
            });
        });

        //Paging dropdown
        context.andFind('.js-product-gallery-select-page').change(function () {
            var selectedPage = $(this).val();
            var formPageNumber = $('.js-product-gallery-page-number');
            formPageNumber.val(selectedPage);

            submitGallery({ IsMobileFilter: false, NoScrollAnimation: true });
        });

        //Pager
        context.andFind('.js-page-li').click(function (e) {
            e.preventDefault();

            var that = $(this);
            if (that.hasClass('disabled')) {
                return;
            }

            var formPageNumber = $('.js-product-gallery-page-number');
            var currentPageNumber = parseInt(formPageNumber.val());

            if (that.hasClass('PagedList-skipToPrevious')) {
                formPageNumber.val(currentPageNumber - 1);
            } else if (that.hasClass('PagedList-skipToNext')) {
                formPageNumber.val(currentPageNumber + 1);
            } else {
                var clickedPageNumber = that.find('a').html();
                formPageNumber.val(clickedPageNumber);
            }

            submitGallery({ IsMobileFilter: false, NoScrollAnimation: true });
        });
    };

    module.productFilteringTrigger = function (context) {
        var bodyContainer = $('html');
        $('.js-trigger-product-filter', context).on('click', function (e) {
            e.preventDefault();
            if (bodyContainer.hasClass('active-product-filtering')) {
                bodyContainer.removeClass('active-product-filtering');
            } else {
                bodyContainer.addClass('active-product-filtering');
            }
        });
    };

    module.designerFilter = function (context) {
        function normalizeSearchTerms(searchTerms) {
            //Convert query text to terms
            var terms = new Array();
            var lastTerm = '';

            function isSeparator(character) {
                var separators = '\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u202F\u3000';
                return separators.indexOf(character) !== -1;
            }

            $(searchTerms.split('')).each(function (index, character) {
                if (isSeparator(character)) {
                    if (lastTerm.length > 0) {
                        terms.push(lastTerm);
                        lastTerm = '';
                    }
                } else {
                    lastTerm += character;
                }
            });

            if (lastTerm.length > 0) {
                terms.push(lastTerm);
            }

            return terms;
        }

        context.andFind(".js-designer-filter").off('input').on("input", function () {
            var $this = $(this);
            var isMobileFilter = $this.hasClass('js-mobile');
            var queryText = $this.val().trim().toLowerCase();
            var queryTextTerms = normalizeSearchTerms(queryText);

            var $namesWrapper = $this.closest('.js-filters-tab, .js-rb-list').find(".js-rb-designers-list");
            var $names = $namesWrapper.find(" > li");
            var matched = false;

            $.each($names, function () {
                var $li = $(this);
                var designerName = $li.find(".text, .mobile-list-heading").text().toLowerCase().trim();

                if (!queryText) {
                    $li.attr("data-relevancy", designerName);
                    return;
                }

                var matches = $.grep(queryTextTerms, function (queryTextTerm) {
                    return designerName.indexOf(queryTextTerm) !== -1;
                }).length;

                if (matches) {
                    matched = true;
                    $li.attr("data-relevancy", '99998_' + designerName);
                } else if (isMobileFilter == false && $li.find('input:checkbox').prop('checked')) {
                    $li.attr("data-relevancy", '99999_' + designerName);
                }
                else {
                    $li.attr("data-relevancy", "hidden");
                }
            });

            if (matched || !queryText) {
                $('.js-mobile-designers-tab').removeClass('no-search-results');
                $('.js-message-no-match').hide();
            } else {
                $('.js-mobile-designers-tab').addClass('no-search-results');
                $('.js-message-no-match').show();
            }

            if (queryText) {
            //Show hide mobile letters
                if (isMobileFilter) {
                    $names.filter('.designer-mobile').each(function () {
                        var $li = $(this);
                        var designerLetter = $li.data('letter-value');

                        var letterNotFiltered = $names
                            .find('.js-refinement-designer')
                            .filter('[data-designer-letter="' + designerLetter + '"]')
                            .closest('li')
                            .filter(":not([data-relevancy='hidden'])")
                            .length > 0;

                        $li.attr("data-relevancy", letterNotFiltered ? "99998_" + designerLetter.toString().toLowerCase() : "hidden");
                });
            } else {
                    $names.filter('.designer-mobile').each(function () {
                    $(this).attr("data-relevancy", "hidden");
                });
            }
            }

            $names
                .show()
                .filter("[data-relevancy='hidden']")
                .hide();

            $names
                .sort(function (a, b) {
                    return a.getAttribute('data-relevancy') > b.getAttribute('data-relevancy') ? 1 : -1;
                })
                .appendTo($namesWrapper);
        });
    };

    module.descriptionTextExpand = function (context) {
        context.andFind(".js-product-description-more-button").on("click", function (e) {
            e.preventDefault();
            $(".js-product-description-more-text").toggleClass("description-text-hide");
            $(".js-product-description-more-ellipsis").toggleClass("description-text-hide");
            var tempText = $(this).text();
            $(this)
                .text($(this).attr("data-swap-text"))
                .attr("data-swap-text", tempText);
        });
    };

    module.toggleMobileFilterLetter = function (context) {
        context.andFind('.js-toggle-filter-letters a').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $scrollWrapper = $('.js-designers-scroll-wrapper');
            var designerLetter = $this.data('letter-value');
            var $targetLi = $scrollWrapper.find('.js-mobile-designer-letter[data-letter-value="' + designerLetter + '"]');

            if ($targetLi.length && $targetLi.position().top != 0) {
                $scrollWrapper.stop(true, true).animate({ scrollTop: $scrollWrapper.scrollTop() + $targetLi.position().top - 50 });
            }
        });
    };

    module.scrollFilterToDesigner = function (context) {
        var mainWrapper = $('.js-rb-designers-list', context),
            activeCheckboxes = mainWrapper.find("input:checked");
        if (activeCheckboxes.length) {
            mainWrapper.stop(true, true).animate({
                scrollTop: (activeCheckboxes.eq(0).offset().top - mainWrapper.offset().top)
            }, 300);
        }
    }

    module.handleMobileFilter = function (context) {
        context.andFind('.js-mobile-filter-all-items-button, .js-mobile-filter-stock-items-button').click(function () {
            var $this = $(this);
            if (!$this.hasClass('active')) {
                $('.js-mobile-filter-all-items-button, .js-mobile-filter-stock-items-button').removeClass('active');
                $this.addClass('active');
                $('.js-products-mobile-filter-navigation .js-product-gallery-select-in-stock').click();
            }
        });

        context.andFind('.js-show-mobile-filter').on('click', function () {
            var self = $(this);
            if (self.hasClass('active-filter')) {
                $('html').removeClass('modal-on filter-open');
                self.removeClass('active-filter');
            } else {
                $('html').addClass('modal-on filter-open');
                self.addClass('active-filter');
            }
        });

        context.andFind('.js-cancel-mobile-filtering').on('click', function (e) {
            e.preventDefault();

            closeMobileFilter();

            if (filteredOnMobileFilter) {
                submitGallery({ SyncMobileFilter: true });
            }
        });

        context.andFind('.js-apply-mobile-filtering').on('click', function (e) {
            e.preventDefault();

            closeMobileFilter();

            if (filteredOnMobileFilter) {
                submitGallery({ ApplyMobileFilter: true, ResetPageNumber: true });
            }
        });

        $(window).resize(function () {
            if (viewport().width > 768) {
                if (!$('.modal-unavailable-size, .modal-size-guide').length) {
                    $('html').removeClass('modal-on filter-open');
                    $('.js-show-mobile-filter').removeClass('active-filter');
                }
            }
        });
    }

    module.detailsSlider = function () {
        var $sliderElement = $(".js-details-slider"),
            slideCount = $('.details-slide').length;
        if ($sliderElement.length == 0) {
            return;
        }

        var $sliderWrapper = $(".js-details-slider-wrapper"),
            $sliderLeft = $(".js-slider-arrow-left"),
            $sliderRight = $(".js-slider-arrow-right"),
            animationTime = 150,
            slidesPerPage = 3,
            touchEnabled = true,
            sliderOptions,
            browser = document.getElementsByTagName('html')[0],
            $detailsSlider,
            uniqueSlidesCount = $sliderElement.find(" > div").filter(":not(.bx-clone)").length;

        if ($sliderElement.attr("data-slider-type") == "landscape") {
            slidesPerPage = 1;
        } else if ($sliderWrapper.width() < 540) {
            slidesPerPage = 1;
        } else if ($sliderWrapper.width() < 960) {
            slidesPerPage = 2;
        }

        if (!(slidesPerPage < uniqueSlidesCount)) {
            touchEnabled = false;
        }

        if (slideCount == 1) {
            $('.page-section').addClass('only-one-slide');
        }

        sliderOptions = {
            controls: false,
            pager: false,
            slideWidth: $sliderWrapper.width() / slidesPerPage,
            speed: animationTime,
            adaptiveHeight: false,
            minSlides: 1,
            maxSlides: slidesPerPage,
            moveSlides: 1,
            easing: "ease-out",
            onSliderLoad: function (currentIndex) {
                site.detailsImageZoom($sliderWrapper);
                $sliderWrapper
                    .height($sliderWrapper.find(".bx-viewport").css("height")); // mobile ios 8 - ipad - chrome - whitespace fix(also css)
                $('.details-slide').eq(currentIndex + 1).addClass('active-zoom-img');
            },
            onSlideBefore: function () {
                $('.details-slide').removeClass('active-zoom-img');
            },
            onSlideAfter: function ($slideElement) {
                $slideElement.addClass('active-zoom-img');
            },
            touchEnabled: touchEnabled
        };

        if (browser.getAttribute("class") == "ie9") {
            sliderOptions.easing = "";
        }

        $detailsSlider = $sliderElement.bxSlider(
            sliderOptions
        );

        $sliderLeft.on("click", function (e) {
            e.preventDefault();
            $detailsSlider.goToPrevSlide();
        });
        $sliderRight.on("click", function (e) {
            e.preventDefault();
            $detailsSlider.goToNextSlide();
        });

        $(window).on("resize", function () {
            if ($sliderElement.attr("data-slider-type") == "landscape") {
                slidesPerPage = 1;
            } else if ($sliderWrapper.width() < 540) {
                slidesPerPage = 1;
            } else if ($sliderWrapper.width() < 960) {
                slidesPerPage = 2;
            } else {
                slidesPerPage = 3;
            }
            sliderOptions.slideWidth = $sliderWrapper.width() / slidesPerPage;
            sliderOptions.maxSlides = slidesPerPage;
            sliderOptions.startSlide = $detailsSlider.getCurrentSlide();
            if (slidesPerPage < uniqueSlidesCount) {
                sliderOptions.touchEnabled = true;
            } else {
                sliderOptions.touchEnabled = false;
            }
            $detailsSlider.reloadSlider(
                sliderOptions
            );
        });

        $sliderWrapper.removeClass("details-slider-before-init");

        $sliderElement.data("details-slider", $detailsSlider);
    };

    core.scopes.on("updateProductCategories", function (event, data, context) {
        var $filterContainer = $('.' + data.filtersContainerClass); 
        var $topCategories =  $filterContainer.find('.js-trigger-parent-category');
        $topCategories.addClass('disabled');

        var $topCategoriesCounts = $topCategories.find('.js-products-top-category-count');
        $topCategoriesCounts.html("0");

        $(data.categoriesCounts).each(function (index, value) {
            $filterContainer.find('.js-products-top-category-count[data-category-id=' + value.CategoryId + ']').html(value.Count);
        });

        var $notActiveCategories = $filterContainer.find('.js-trigger-category:not(.active)');
        $notActiveCategories.addClass('disabled');

        $(data.availableCategoryIds).each(function (index, value) {
            var $topCategory = $filterContainer.find('.js-trigger-parent-category[data-category-id=' + value + ']');
            $topCategory.removeClass('disabled');

            var $category = $filterContainer.find('.js-trigger-category[data-category-id=' + value + ']');
            $category.removeClass('disabled');
        });
    });

    function init() {
        module.detailsSlider();
    };

    // Initialize
    $(document).ready(function () {
        init();
        core.scopes.addHandler('*', function (context) {
            module.onProductGalleryAction(context);
            module.designerFilter(context);
            module.productFilteringTrigger(context);
            module.scrollFilterToDesigner(context);
            module.slideTopContent(context);
            module.handleMobileFilter(context);
            module.triggerFilteredDesigners(context);
            module.toggleMobileFilterLetter(context);

            module.descriptionTextExpand(context);
        });
    });

    return module;
});
